import React from 'react';
import { HubGameShortcuts } from '@precisionpros/game-ui';
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
export default function QuickLinks({ playerName = '' }) {
  return <HubGameShortcuts currentGameKey="wordprofinder" playerName={playerName}
    homeHref={isLocal ? 'http://localhost:3000' : 'https://games.precisionpros.com'} />;
}
